<template>
    <div class="deck-card-regular" :class="{'selected': selected}" @click.self="selectCardDeck">
        <div class="deck-card-regular__image" @click="selectCardDeck">
            <img class="img-fluid" :src="cardDeck.central_image"/>
            <div class="deck-card-regular__status-badge" v-if="cardDeck.shared_on_community">
                <inline-svg src="/assets/img/icons/share-06-white.svg"></inline-svg>
                Shared in community
            </div>
<!--            <div class="deck-card-regular__status-badge">-->
<!--                <inline-svg src="/assets/img/icons/globe-02.svg"></inline-svg>-->
<!--                From community-->
<!--            </div>-->
        </div>
        <div class="d-flex flex-row w-100 align-items-center justify-content-between gap-2" style="margin-top: 24px;">
            <span class="deck-card-regular__date">Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}</span>
            <avatar-group v-if="!communityCard && cardDeck.assigned_heroes"
                          size="xs"
                          :hidePlusIcon="true"
                          :users="cardDeck.assigned_heroes">
            </avatar-group>
        </div>
        <div class="flex-1 w-100" @click="selectCardDeck">
            <div
                class="deck-card-regular__title mt-2 text-truncate">
                {{ cardDeck.title }}
            </div>
            <div class="d-flex flex-row w-100 justify-content-between mt-2">
                <div class="d-flex gap-1">
                    <span class="deck-card-regular__category-label">{{ cardDeck.category.label }}</span>
                    <span class="deck-card-regular__category-label cards-counter">
                        {{ cardDeck.cards.length }} {{ cardDeck.cards.length === 1 ? 'card' : 'cards'}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import AvatarGroup from "@/components/AvatarGroup.vue";

export default {
    name: 'DeckCardBasic',
    props: ['cardDeck', 'selected', 'communityCard'],
    components: {AvatarGroup},
    data() {
        return {
        }
    },
    methods: {
        selectCardDeck() {
            this.$emit('onSelect');
        },
    }
};

</script>
